module.exports = __webpack_public_path__ + "static/media/tour-2.5746b343.png";